var AlertType = /* @__PURE__ */ ((AlertType2) => {
  AlertType2["DANGER"] = "DANGER";
  AlertType2["NORMAL"] = "NORMAL";
  AlertType2["PROGRESS"] = "PROGRESS";
  AlertType2["SUCCESS"] = "SUCCESS";
  AlertType2["ERROR"] = "ERROR";
  AlertType2["INFO"] = "INFO";
  AlertType2["WARNING"] = "WARNING";
  AlertType2["CONSOLE"] = "CONSOLE";
  AlertType2["ETC"] = "ETC";
  return AlertType2;
})(AlertType || {});
export {
  AlertType
};
//# sourceMappingURL=AlertType.js.map
